export class LembreteContagem {
  todos = 0;
  pendentes = 0;
  concluidos = 0;
  erros = 0;
}
